module.exports = __webpack_public_path__ + "img/help_card_01.69991c6a.png";